import { render, staticRenderFns } from "./materials-filters.vue?vue&type=template&id=22575938"
import script from "./materials-filters.vue?vue&type=script&lang=js"
export * from "./materials-filters.vue?vue&type=script&lang=js"
import style0 from "./materials-filters.vue?vue&type=style&index=0&id=22575938&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports